// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"e381cb65","703":"66e39408"}[chunkId] + ".chunk.js";
};